import React from 'react'
import './About.css';
import { useState } from 'react';
import ME2 from '../../assets/image1.jpg';
import { FaAward } from "react-icons/fa6";
import { HiUsers } from "react-icons/hi2";
import { FaCircleCheck } from "react-icons/fa6";
import StatCounter from './StatCounter';
import { motion } from 'framer-motion';

const About = () => {
  // Array of images (hover cycles through them if more are added later)
  const images = [ME2];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const handleImageHover = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  return (
    <section id='about'>
      <h5>Get To Know Me</h5>
      <h2>My Journey</h2>

      <motion.div 
        className="container about__container"
        initial={{ opacity: 0, y: 50, rotateX: 8 }}
        whileInView={{ opacity: 1, y: 0, rotateX: 0 }}
        viewport={{ once: true, margin: '-80px' }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
        style={{ perspective: 1000 }}
      >
        <div className="about__me">
          <div className="about__me-image" onMouseEnter={handleImageHover}>
            <img src={images[currentImageIndex]} alt="Syed Maaz Saeed" />
          </div>
        </div>

        <div className="about__content">
          <div className="about__cards">
            <article className='about__card'>
              <FaAward className='about__icon'/>
              <h5 className='about__card-number'><StatCounter end={5} suffix="+" /></h5>
              <h5>Years Experience</h5>
              <small className='text-light'>Hands-on coding & AI engineering</small>
            </article>

            <article className='about__card'>
              <HiUsers className='about__icon'/>
              <h5 className='about__card-number'><StatCounter end={50} suffix="+" /></h5>
              <h5>Clients Worldwide</h5>
              <small className='text-light'>Across legal, health & real estate</small>
            </article>

            <article className='about__card'>
              <FaCircleCheck className='about__icon'/>
              <h5 className='about__card-number'><StatCounter end={50} suffix="+" /></h5>
              <h5>Projects Delivered</h5>
              <small className='text-light'>Web apps, AI agents & automations</small>
            </article>
          </div>

          <p>
            Hi Everyone, I'm <strong>Syed Maaz Saeed</strong> from Bahawalpur, Pakistan. I'm an <strong>AI Solutions Architect & Full Stack Engineer</strong> who loves building intelligent web applications and AI-powered automation systems that solve real business problems.
          </p>

          <p>
            I work with modern technologies like <strong>React.js</strong>, <strong>Next.js</strong>, <strong>Node.js</strong>, and <strong>MongoDB</strong> to create scalable, high-performance web applications. Beyond traditional development, I specialize in <strong>AI automation</strong> designing conversational AI agents with <strong>OpenAI and ElevenLabs</strong>, building lifelike voice and text agents, and creating intelligent workflows using <strong>n8n, Make, and Zapier</strong> that streamline business operations and eliminate repetitive tasks.
          </p>

          <p>
            I started my journey as a self-taught <strong>Front-End and React developer</strong>, and today I combine that foundation with my passion for <strong>AI engineering and intelligent automation</strong>. With over <strong>five years of hands-on experience</strong>, I have delivered <strong>40+ production-ready AI workflows</strong> for clients across legal, healthcare, and real estate industries. I actively contribute to open-source projects and love staying at the cutting edge of technology.
          </p>

          <p>
            I completed my <strong>ICS in Mathematics and Computer Science</strong> at Superior Group of Colleges, Bahawalpur, and later graduated with a Bachelor's in <strong>Software Engineering</strong> from The Islamia University of Bahawalpur in July 2025, where I was honored as the <strong>Gold Medalist and Department Topper</strong>. Learning and innovation have always been my driving forces, and my focus now is on building solutions that bring together modern web technologies and AI automation making digital experiences smarter, faster, and more impactful.
          </p>

          <p className="about__quote" style={{ marginTop: '1.5rem', fontStyle: 'italic', fontWeight: '600' }}>
            "I Build Intelligent Web Applications and AI Automation Systems That Drive Business Growth and Maximize Productivity."
          </p>

          <a href="#contact" className='btn btn-primary btn-swing'>Let's Connect</a>
        </div>
      </motion.div>
    </section>
  )
}

export default About
